import classNames from "classnames"
import React from "react"

import { useTranslation, formatNumber, useFormatDecimals, Trans } from "@bounce/i18n"
import { RatingStars } from "@bounce/web-components"

export type AppAggregateRatingProps = {
  count: number
  rating: number
  className?: string
  textClassName?: string
  starClassName?: string
}

export const AppAggregateRating = ({
  rating,
  count,
  className,
  textClassName,
  starClassName,
}: AppAggregateRatingProps) => {
  const { i18n } = useTranslation()
  const formatRating = useFormatDecimals({ maxDecimalPlaces: 1 })
  const numReviews = formatNumber(count, i18n.language)

  return (
    <div className={classNames("flex flex-row items-center", className)}>
      <RatingStars ratingScore={rating} starClassName={classNames("text-primary-700", starClassName)} />
      <span className={classNames(textClassName, "label2 ml-2 text-neutral-800")}>
        <Trans
          ns="marketing"
          i18nKey="cmp.rating.ratedWithBold"
          defaults="Rated <bold>{{rating}}/5</bold> ({{numReviews}} reviews)"
          components={{
            bold: <span className="font-semibold text-primary" />,
          }}
          values={{
            rating: formatRating(rating),
            numReviews,
          }}
        />
      </span>
    </div>
  )
}
